{
  "hero": {
    "title": "Turn Your Product Catalog into",
    "subtitle": "AI Shopping Advisors",
    "description": "Deploy conversational salesforce that sell — not just chat. On your website, social media, WhatsApp, and ChatGPT.",
    "createAssistant": "Create AI Assistant",
    "bookDemo": "Book a Demo"
  },
  "nav": {
    "solutions": "Solutions",
    "products": "Products",
    "pricing": "Pricing",
    "caseStudies": "Case Studies",
    "blog": "Blog",
    "contact": "Contact",
    "shoppingExpert": "Shopping Expert",
    "gptStore": "GPT Store"
  },
  "chat": {
    "greeting": "Hi there! I'm your AI shopping assistant. Try asking me about products like TVs, laptops, or coffee makers. How can I help you today?",
    "placeholder": "Type your message here...",
    "contact": {
      "heading": "Please share your contact information"
    }
  },
  "sections": {
    "partners": {
      "title": "Trusted by leading platforms"
    },
    "gptPromo": {
      "title": "Launch Your Brand in the GPT Store",
      "description": "Create a custom GPT shopping assistant that showcases your products and converts browsers into buyers."
    },
    "solutions": {
      "title": "Industry Solutions",
      "subtitle": "AI shopping advisors tailored for your industry",
      "electronics": {
        "title": "Electronics & Tech",
        "description": "Help customers navigate complex tech specs and find the perfect device.",
        "items": [
          "Smart product comparisons",
          "Technical specification matching",
          "Compatibility checking",
          "Performance recommendations"
        ]
      },
      "fashion": {
        "title": "Fashion & Apparel",
        "description": "Provide personalized styling advice and size recommendations.",
        "items": [
          "Style matching and recommendations",
          "Size and fit guidance",
          "Seasonal trend advice",
          "Outfit coordination"
        ]
      },
      "home": {
        "title": "Home & Garden",
        "description": "Guide customers through home improvement and decor decisions.",
        "items": [
          "Room design consultation",
          "Appliance recommendations",
          "Space optimization advice",
          "Maintenance guidance"
        ]
      },
      "agency": {
        "title": "Agencies & Partners",
        "description": "White-label solutions for agencies serving multiple retail clients.",
        "items": [
          "Multi-client management",
          "Custom branding options",
          "Analytics and reporting",
          "Agency partner support"
        ]
      }
    },
    "platforms": {
      "title": "Supported platform"
    },
    "valueProps": {
      "title": "Why Choose Shopilots?",
      "subtitle": "Transform your retail experience with AI that actually sells",
      "conversion": {
        "title": "Boost Conversions",
        "description": "Turn browsers into buyers with personalized product recommendations and guided shopping experiences.",
        "metric": "Conversion Rate"
      },
      "aov": {
        "title": "Increase AOV",
        "description": "Smart upselling and cross-selling suggestions that feel natural and helpful to customers.",
        "metric": "Average Order Value"
      },
      "returns": {
        "title": "Reduce Returns",
        "description": "Better product matching means customers get exactly what they need the first time.",
        "metric": "Return Rate"
      },
      "advantage": {
        "title": "The Shopilots Advantage",
        "description": "Unlike generic chatbots, our AI understands your products and speaks your brand voice.",
        "features": {
          "catalog": "Real-time catalog integration",
          "sales": "Sales-focused conversations",
          "channels": "Multi-channel deployment",
          "analytics": "Revenue-driven analytics"
        }
      },
      "testimonial": {
        "title": "Customer Success",
        "quote": "Shopilots transformed our online sales. Customers find products faster and buy more confidently.",
        "name": "Sarah Johnson",
        "position": "E-commerce Director"
      }
    }
  },
  "micro": {
    "demoMode": "Demo Mode"
  },
  "forms": {
    "name": "Name",
    "email": "Email",
    "company": "Company",
    "phone": "Phone",
    "optional": "optional",
    "thankYou": "Thank You!"
  },
  "buttons": {
    "sending": "Sending...",
    "submit": "Submit",
    "launchAssistant": "Launch Your AI Assistant",
    "callUs": "Call Us",
    "learnMore": "Learn More",
    "getStarted": "Get Started",
    "findSolution": "Find Your Solution"
  },
  "footer": {
    "description": "AI shopping advisors that sell — not just chat. Deploy on your website, social media, WhatsApp, and ChatGPT.",
    "solutions": "Solutions",
    "resources": "Resources",
    "contactUs": "Contact Us",
    "copyright": "All rights reserved.",
    "links": {
      "privacyPolicy": "Privacy Policy",
      "termsOfService": "Terms of Service",
      "sitemap": "Sitemap"
    }
  }
}